'use strict';
import { gsap } from 'gsap';
import { slideUpLetters } from '../../utility/_modules';
function initWorkTab() {
  const tabs = document.querySelectorAll('.js-tab');
  function tabSwitch() {
    let tabsArray = Array.prototype.slice.call(tabs);
    let index = tabsArray.indexOf(this);
    const resetTab = function () {
      document
        .querySelector('.works-tab-item.tab-active')
        .classList.remove('tab-active');
      document
        .querySelector('.js-tab[aria-selected=true]')
        .removeAttribute('aria-selected');
      document.querySelectorAll('.works-tab-item').forEach((elm) => {
        elm.tabIndex = -1;
      });
      document
        .querySelector('.js-tab-panel.panel-active')
        .classList.remove('panel-active');
    };
    const setTab = function (tab, tabpanel) {
      tab.classList.add('tab-active');
      tab.tabIndex = 0;
      tab.setAttribute('aria-selected', true);
      tabpanel.classList.add('panel-active');
    };
    if (event.type == 'keyup') {
      if (event.key === 'ArrowRight') {
        if (tabsArray[index + 1]) {
          tabsArray[index + 1].focus();
          resetTab();
          setTab(
            tabsArray[index + 1],
            document.querySelectorAll('.js-tab-panel')[index + 1]
          );
        } else {
          tabsArray[0].focus();
          resetTab();
          setTab(tabsArray[0], document.querySelectorAll('.js-tab-panel')[0]);
        }
      }
      if (event.key === 'ArrowLeft') {
        if (tabsArray[index - 1]) {
          tabsArray[index - 1].focus();
          resetTab();
          setTab(
            tabsArray[index - 1],
            document.querySelectorAll('.js-tab-panel')[index - 1]
          );
        } else {
          let lastTab = tabsArray.pop();
          lastTab.focus();
          resetTab();
          setTab(
            lastTab,
            Array.prototype.slice
              .call(document.querySelectorAll('.js-tab-panel'))
              .pop()
          );
        }
      }
    }
    if (event.type == 'click') {
      resetTab();
      setTab(this, document.querySelectorAll('.js-tab-panel')[index]);
    }
  }
  tabs.forEach((tab) => {
    tab.addEventListener('click', tabSwitch);
    tab.addEventListener('keyup', tabSwitch);
  });
}

function initKv() {
  // const kvWing = document.querySelectorAll('.page-kv__bg');
  const slideUpTarget = document.querySelectorAll(
    '.archive-index-kv-title__en'
  );
  const initLayerKvtl = gsap.timeline();
  initLayerKvtl
    .add(slideUpLetters(slideUpTarget), 'start')
    // テキストの右上羽生える
    .add(() => {
      document
        .querySelector('.handwritingText__maskLine')
        .classList.add('is-active');
    }, '+=1')
    // 右側の大きい羽表示
    // .to(kvWing, {
    //   duration: 1,
    //   opacity: 1,
    // })
    // 日本語タイトル右から左
    .add(() => {
      document
        .querySelector('.archive-index-kv-title__ja')
        .classList.add('is-active');
    }, '+=0.5')
    .add(() => {
      document
        .querySelector('.archive-index-kv__foot')
        .classList.add('is-active');
    }, '+=0.5')
    // パンくず表示
    .add(() => {
      document.querySelector('.page-breadcrumb').classList.add('is-active');
    }, '<');

  // 3秒くらい？
}
window.addEventListener('DOMContentLoaded', () => {
  initWorkTab();
  initKv();
});
